import React from 'react';
import { ShieldOff } from 'lucide-react';
import { useAuth } from '../auth/AuthProvider';
import { routeRoleFor, roleAllows } from '../lib/roleGates';
import { permissionsCopy } from '../copy/permissions';
import { EmptyState } from '@/components/ui/empty-state';
import { BlockedPage } from './BlockedPage';

/**
 * Renders the page, or a plain card when it belongs to a role this user
 * doesn't have (organisation admin pages, the platform console). Sits
 * outside the plan and permission guards: there's nothing to upgrade.
 */
export function RouteRoleGuard({ pathname, children }: { pathname: string; children: React.ReactNode }) {
  const { user } = useAuth();
  const gate = routeRoleFor(pathname);
  if (!gate || roleAllows(gate, user)) return <>{children}</>;
  const copy = permissionsCopy.roleGate[gate];
  return (
    <BlockedPage pathname={pathname}>
      <EmptyState icon={ShieldOff} title={copy.title} body={copy.body} className="mx-auto max-w-xl" />
    </BlockedPage>
  );
}
